module.exports = __webpack_public_path__ + "image/header_img_zw1.jpg";